﻿{
  "favoriteBoardmakerSoftware": "ulubione oprogramowanie Boardmaker",
  "planDetailsStartTrial": "Rozpocznij dziś bezpłatną wersję próbną, która zapewnia dostęp przez 30 dni!",
  "community": {
    "summary": "Skorzystaj z gotowych i łatwo dostępnych materiałów edukacyjnych udostępnianych przez rodziców, nauczycieli i terapeutów – osoby takie jak Ty! Zaoszczędź czas, wyszukując i filtrując ćwiczenia oraz szablony, a następnie dodając je do swojego konta, aby edytować i otwierać w ulubionym oprogramowaniu Boardmaker. Czeka na Ciebie 60 tys. BEZPŁATNYCH zajęć interaktywnych i do druku oraz 500 tys. członków społeczności!",
    "topReasons": {
      "header": "Najważniejsze powody, aby dołączyć do społeczności myBoardmaker Community",
      "points": [
        "Udostępniaj swoje unikalne materiały",
        "Korzystaj z rozbudowanych funkcji wyszukiwania, aby odnaleźć dokładnie to, czego potrzebujesz",
        "Wyszukuj ćwiczenia profesjonalnie opracowane przez zespół Boardmaker Education Team",
        "Wyszukuj ćwiczenia dostosowane do standardów Common Core",
        "Dołącz do grup właściwych dla Twoich zainteresowań"
      ]
    },
    "summaryEnd": "Udostępniaj i odkrywaj materiały interaktywne i do druku, które zapewniają wsparcie behawioralne i wzmacniają niezależność wśród uczniów, a także rozwijają umiejętności – wszystko to BEZPŁATNIE.",
    "features": [
      {
        "featureTitle": "Znajduj",
        "featureDescription": "Odkryj zindywidualizowany program nauczania, harmonogramy z grafiką, tablice informacyjne, ćwiczenia dostosowane do standardów edukacyjnych i inne materiały pomocnicze, które zostały opracowane i wykorzystane przez rodziców, terapeutów i nauczycieli."
      },
      {
        "featureTitle": "Udostępniaj",
        "featureDescription": "Przesyłaj własne ćwiczenia, uczestnicz w dyskusjach, twórz grupy publiczne i prywatne, aby dzielić się materiałami i nie tylko."
      },
      {
        "featureTitle": "Korzystaj",
        "featureDescription": "Zapisuj swoje ćwiczenia online i uzyskuj do nich dostęp z dowolnego komputera."
      },
      {
        "featureTitle": "Nawiązuj kontakt",
        "featureDescription": "Kontaktuj się z innymi osobami, które nauczają podobnego przedmiotu lub w tej samej klasie, wymieniaj się pomysłami z rodzicami, którzy stoją przed podobnymi wyzwaniami, i udostępniaj własne rozwiązania."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 lub późniejsze"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 lub późniejsze"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 lub późniejsze"]
      ],
      "browser": [
        ["Chrome", "v49.0", "bieżące"],
        ["Firefox", "v38.0", "bieżące"],
        ["Safari", "v11.0", "bieżące"],
        ["Edge", "v83.0.478.45", "bieżące"],
        ["Internet Explorer", "v10.0", "v11.0 lub późniejsze"]
      ]
    }
  },
  "personal": {
    "summary": "Wnieś możliwości, jakie daje Boardmaker, do swojego domu. Subskrypcja osobista myBoardmaker zapewnia Ci możliwość podjęcia aktywnej roli w budowie sukcesu własnego dziecka poprzez uspójnienie edukacji w domu, szkole i w ramach terapii, dając okazję do poszerzenia nauki poza dzień szkoły, a nawet rok szkolny. Twórz sieci kontaktów z innymi rodzicami w społeczności Boardmaker, aby udostępniać własne materiały i pozyskiwać pomysły na kolejne prace.",
    "topReasons": {
      "header": "Najważniejsze powody, aby wybrać Subskrypcję osobistą myBoardmaker",
      "points": [
        "Korzystaj z angażujących i interaktywnych ćwiczeń na dowolnym komputerze lub iPadzie",
        "Drukuj ćwiczenia, gdy tylko ich potrzebujesz",
        "Jako rodzic, bierz aktywny udział w procesie edukacyjnym swojego dziecka w domu",
        "Zabieraj ciekawe i angażujące materiały, gdy tylko wybierasz się w drogę, i twórz lub edytuj ćwiczenia na dowolnym komputerze"
      ]
    },
    "summaryEnd": "Rozpocznij dziś bezpłatną wersję próbną, która zapewnia pełny dostęp przez 30 dni!",
    "features": [
      {
        "featureTitle": "Twórz i edytuj",
        "featureDescription": "Twórz i edytuj ćwiczenia z dostosowanymi symbolami, takie jak harmonogramy z grafiką do zaplanowania dnia, zindywidualizowane podręczniki i materiały do nauki, a także materiały kształtujące zachowanie! Dzięki bibliotece przeszło 80 tys. symboli do wyboru, a także nowych, dodawanych co dwa tygodnie, możliwości są nieograniczone. Potrzebujesz więcej? Użyj naszej opcji wyszukiwania w internecie, aby dodać pliki multimedialne do swojego projektu."
      },
      {
        "featureTitle": "Drukuj i odtwarzaj materiały",
        "featureDescription": "Drukuj własne ćwiczenia lub wyszukuj je w społeczności Boardmaker bezpośrednio z przeglądarki internetowej, aby używać ich następnie w nauce. Chcesz zwiększyć zaangażowanie ucznia? Wypróbuj nasze interaktywne szablony i ćwiczenia. Dzieci i rodzice mogą z łatwością korzystać z ćwiczeń za pomocą bezpłatnej aplikacji Student Center na tabletach lub urządzeniach do komunikacji."
      },
      {
        "featureTitle": "Nauczaj i poszerzaj zakres dziedzin",
        "featureDescription": "Szybko rozwiń umiejętności dotyczące czytania i języków u swojego dziecka dzięki dostępowi do naszych trzech prostych w obsłudze programów nauczania. Rozpocznij od Core First Learning – narzędzia, które pomaga dziecku uczyć się znaczeń, wykorzystania i zasad składni dla często używanych słów podstawowych. To idealne rozwiązanie dla osób korzystających ze wspomagających systemów komunikacji lub tych, które uczą się czytania! Zastosuj nowe umiejętności do lektur, korzystając z Book Bridge, a następnie rozpocznij rozwijanie wiedzy o świecie poprzez badanie historii, geografii, życia i kultury z Expedition Education."
      },
      {
        "featureTitle": "Wyszukuj i udostępniaj materiały",
        "featureDescription": "Po co odkrywać koło od nowa? Wybieraj spośród 60 tys. BEZPŁATNYCH, gotowych do druku i interaktywnych ćwiczeń oraz 1100 publicznych grup z podziałem na kategorie w społeczności Boardmaker – największej tego rodzaju społeczności na świecie. Możesz także przesyłać własne ćwiczenia na konto społeczności myBoardmaker Community i udostępniać je rodzicom, terapeutom lub zespołowi wsparcia dla własnego dziecka."
      },
      {
        "featureTitle": "Monitoruj i śledź postępy",
        "featureDescription": "Monitoruj i śledź postępy swojego dziecka podczas pracy z ćwiczeniami, aby zadbać o jego sukces i określić najskuteczniejsze podejście do nauki."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 lub późniejsze"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 lub późniejsze"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 lub późniejsze"]
      ],
      "browser": [
        ["Chrome", "v49.0", "bieżące"],
        ["Firefox", "v38.0", "bieżące"],
        ["Safari", "v11.0", "bieżące"],
        ["Edge", "v83.0.478.45", "bieżące"],
        ["Internet Explorer", "v10.0", "v11.0 lub późniejsze"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional to najbardziej kompleksowy system dla nauczycieli edukacji specjalnej, foniatrów i logopedów, terapeutów zajęciowych oraz behawioralnych i nie tylko, w którym można wyszukiwać, tworzyć, organizować i przesyłać spersonalizowane, wizualne materiały pomocnicze, pomoce naukowe z symbolami i ćwiczenia terapeutyczne, które odpowiadają potrzebom uczniów w klasie lub w ramach terapii.",
    "topReasons": {
      "header": "Najważniejsze powody, aby wybrać Subskrypcję profesjonalisty myBoardmaker",
      "points": [
        "Zarządzaj ćwiczeniami uczniów i je przydzielaj z dowolnego miejsca, na każdym komputerze",
        "Korzystaj z dużej biblioteki dostosowanych do standardów ćwiczeń przykładowych lub twórz własne",
        "Uczniowie mogą korzystać z ćwiczeń instruktażowych na dowolnym komputerze lub iPadzie w szkole bądź w domu",
        "Zbieraj dane i śledź postępy uczniów w realizacji celów indywidualnego toku nauki i zachowanie standardów edukacyjnych",
        "Wbudowane narzędzia pomocą Ci współpracować i udostępniać materiały innym członkom zespołu"
      ]
    },
    "summaryEnd": "Rozpocznij dziś bezpłatną wersję próbną, która zapewnia pełny dostęp przez 30 dni!",
    "features": [
      {
        "featureTitle": "Twórz i edytuj",
        "featureDescription": "Twórz i edytuj ćwiczenia z dostosowanymi symbolami, takie jak harmonogramy z grafiką do zaplanowania dnia, zindywidualizowane podręczniki i materiały do nauki, a także materiały kształtujące zachowanie! Dzięki bibliotece przeszło 80 tys. symboli do wyboru, a także nowych, dodawanych co dwa tygodnie, możliwości są nieograniczone. Potrzebujesz więcej? Użyj naszej opcji wyszukiwania w internecie, aby dodać pliki multimedialne do swojego projektu."
      },
      {
        "featureTitle": "Drukuj i odtwarzaj materiały",
        "featureDescription": "Drukuj własne ćwiczenia lub wyszukuj je w społeczności Boardmaker bezpośrednio z przeglądarki internetowej, aby używać ich następnie w nauce. Chcesz zwiększyć zaangażowanie ucznia? Wypróbuj nasze interaktywne szablony i ćwiczenia. Dzieci i rodzice mogą z łatwością korzystać z ćwiczeń za pomocą bezpłatnej aplikacji Student Center na tabletach lub urządzeniach do komunikacji."
      },
      {
        "featureTitle": "Nauczaj i poszerzaj zakres dziedzin",
        "featureDescription": "Pomóż uczniom zrobić kolejny krok w podróży edukacyjnej, wykorzystując dostęp do trzech kompleksowych, dostosowanych do standardów programów nauczania. Dołączone do subskrypcji myBoardmaker, rozwiązanie Boardmaker Instructional Solutions zapewnia przeszło 140 szczegółowych planów lekcji, ponad 1500 zróżnicowanych i zgodnych ze standardami ćwiczeń, 300+ przystępnych podręczników do druku, narzędzia do zarządzania klasą, testy, gry, wzorce, układanki i nie tylko!"
      },
      {
        "featureTitle": "Wyszukuj i udostępniaj materiały",
        "featureDescription": "Po co wynajdować koło od nowa? Wybieraj spośród 60 tys. BEZPŁATNYCH, gotowych do druku i interaktywnych ćwiczeń oraz 1100 publicznych grup z podziałem na kategorie w społeczności Boardmaker – największej tego rodzaju społeczności na świecie. Możesz także przesyłać własne ćwiczenia na konto społeczności myBoardmaker Community i udostępniać je rodzicom, terapeutom lub zespołowi wsparcia dla własnego dziecka."
      },
      {
        "featureTitle": "Monitoruj i śledź postępy",
        "featureDescription": "Monitoruj i śledź postępy swojego dziecka podczas pracy z ćwiczeniami, aby zadbać o jego sukces i określić najskuteczniejsze podejście do nauki."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 lub późniejsze"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 lub późniejsze"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 lub późniejsze"]
      ],
      "browser": [
        ["Chrome", "v49.0", "bieżące"],
        ["Firefox", "v38.0", "bieżące"],
        ["Safari", "v11.0", "bieżące"],
        ["Edge", "v83.0.478.45", "bieżące"],
        ["Internet Explorer", "v10.0", "v11.0 lub późniejsze"]
      ]
    }
  },
  "organization": {
    "summary": "Subskrypcja instytucjonalna myBoardmaker wspiera Twój zespół multidyscyplinarny, zapewniając przystosowane ćwiczenia, materiały kształtujące zachowania i metody pomiary postępów w realizacji celów, zgodnie ze standardami. \n\nOparty na chmurze system myBoardmaker zapewnia ramy dla spójnej współpracy w całej organizacji, umożliwiając personelowi pracę z każdego miejsca. Ponadto zapewnia dostęp do zbioru przeszło 60 tys. przygotowanych ćwiczeń, trzech pełnych programów nauczania oraz ponad 80 tys. wspomagających naukę symboli obrazkowych, które przyspieszą planowanie lekcji. Teraz Twój zespół może szybko dostarczać interaktywne ćwiczenia i zadania do druku swoim uczniom lub klientom, korzystając z Boardmaker Student Center, aby rozszerzyć naukę i terapię – wystarczy do tego kliknięcie przycisku!\n\nKontroluj pracę zespołu i poprawiaj wydajność w całej organizacji dzięki scentralizowanym funkcjom zarządzania kontami i danymi, a także zaawansowanym narzędziom do współpracy i udostępniania materiałów.",
    "topReasons": {
      "header": "Najważniejsze powody, aby dołączyć do organizacji myBoardmaker",
      "points": [
        "Oparty na chmurze system zapewnia ramy dla spójnej współpracy w całej organizacji, umożliwiając personelowi pracę z każdego miejsca.",
        "Rozległy zbiór przykładowych ćwiczeń dostosowanych do standardów szkół średnich i ścieżek gotowości do kariery (Career Readiness), a także określonych standardów krajowych",
        "Uczniowie mogą korzystać z ćwiczeń instruktażowych na każdym komputerze, z dowolnego miejsca",
        "Ćwiczenia mogą być powiązane z celami indywidualnego toku nauki, tak aby zademonstrować osiągnięcia uczniów",
        "Natychmiastowy dostęp do wyników uczniów i pracy instruktorów – wszystko z jednego systemu"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Twórz i edytuj",
        "featureDescription": "Twórz i edytuj ćwiczenia z dostosowanymi symbolami, takie jak harmonogramy z grafiką do zaplanowania dnia, zindywidualizowane podręczniki i materiały do nauki, a także materiały kształtujące zachowanie! Dzięki bibliotece przeszło 80 tys. symboli do wyboru, a także nowych, dodawanych co dwa tygodnie, możliwości są nieograniczone. Potrzebujesz więcej? Użyj naszej opcji wyszukiwania w internecie, aby dodać pliki multimedialne do swojego projektu."
      },
      {
        "featureTitle": "Drukuj i odtwarzaj materiały",
        "featureDescription": "Drukuj własne ćwiczenia lub wyszukuj je w społeczności Boardmaker bezpośrednio z przeglądarki internetowej. Chcesz zwiększyć zaangażowanie ucznia? Zachęć swój zespół do wykorzystania naszych interaktywnych szablonów i ćwiczeń. Uczniowie mogą z łatwością odtwarzać ćwiczenia za pomocą bezpłatne, łatwo dostępnej aplikacji Student Center bez konieczności połączenia z internetem."
      },
      {
        "featureTitle": "Nauczaj i poszerzaj zakres dziedzin",
        "featureDescription": "Zapewnij swojemu zespołowi dostęp do trzech kompleksowych, zgodnych ze standardami programów nauczania, objętych Subskrypcją instytucjonalną myBoardmaker. Rozwiązanie Boardmaker Instructional Solutions zapewnia przeszło 140 szczegółowych planów lekcji, ponad 1500 zróżnicowanych i zgodnych ze standardami ćwiczeń, 300+ przystępnych podręczników do druku, narzędzia do zarządzania klasą, testy, gry, wzorce, układanki i nie tylko!"
      },
      {
        "featureTitle": "Przydzielaj zadania i śledź postępy",
        "featureDescription": "Korzystając z konta instytucjonalnego myBoardmaker, pracownicy mogą przydzielać spersonalizowane i dostosowane do jednego poziomu ćwiczenia dla nieograniczonej liczby uczniów, aby śledzić ich postępy wraz z realizacją celów indywidualnego toku nauki przy zachowaniu lokalnych standardów. Mogą korzystać z naszego narzędzia Progress Monitoring, aby szybko sprawdzać wyniki uczniów i z łatwością wspierać ich sukces. Przydzielane ćwiczenia wykonywane w domu także są śledzone, umożliwiając wydajne zarządzanie pracą domową i nawiązanie partnerstwa z rodziną dziecka w celu poszerzenia jego nauki poza klasę."
      },
      {
        "featureTitle": "Wyszukuj i udostępniaj materiały",
        "featureDescription": "Po co wynajdować koło od nowa? Wybieraj spośród 60 tys. BEZPŁATNYCH, gotowych do druku i interaktywnych ćwiczeń oraz 1100 publicznych grup z podziałem na kategorie w społeczności Boardmaker – największej tego rodzaju społeczności na świecie. Możesz także przesyłać własne ćwiczenia na konto społeczności myBoardmaker Community i udostępniać je rodzicom, terapeutom lub zespołowi wsparcia dla własnego dziecka."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Ograniczenie kosztów",
        "advantagePoints": [
          "Wyjątkowe spersonalizowane pakiety 5+ kont dla instytucji",
          "Chmurowe usługi umożliwiają łatwe przydzielanie licencji w ramach transakcji zespołowej",
          "Cennik licencji",
          "Pakiety wielu produktów",
          "Oszczędności przez lata"
        ]
      },
      {
        "advantageTitle": "Sukces dla każdego",
        "advantagePoints": [
          "Oparte na badaniach i gotowe do użytku ćwiczenia zapewniają pozytywne i mierzalne wyniki",
          "Nasze specjalnie dostosowane materiały edukacyjne i ćwiczenia, bazujące na zasadach Universal Design for Learning, umożliwiają osiąganie celów przez osoby o zróżnicowanych zdolnościach",
          "Zaadaptowany program nauczania zapewnia taką samą dostępność dla każdego",
          "Zasoby, które odzwierciedlają najlepsze praktyki specjalistów, dzięki którym wykorzystasz pełen potencjał swoich rozwiązań"
        ]
      },
      {
        "advantageTitle": "Wsparcie dla standardów i wymagań",
        "advantagePoints": [
          "Rozwiązania zaprojektowane z myślą o nauczaniu i mierzeniu postępów w przygotowaniu do szkół średnich i ścieżek kariery",
          "Szeroki wachlarz rozwiązań, które wpierają wymagania określone przez Universal Design for Learning, Every Child Succeeds oraz Ustawę o edukacji osób niepełnosprawnych",
          "Automatycznie śledź i raportuj postępy w realizacji celów indywidualnego toku nauki za pomocą paneli nawigacyjnych danych"
        ]
      },
      {
        "advantageTitle": "Łatwe wdrożenie w organizacji",
        "advantagePoints": [
          "Umożliwia administratorom zdalne wdrażanie kont w przeciągu sekund",
          "Elastyczne i skalowalne opcje wdrożenia w organizacji",
          "Wszystkie rozwiązania chmurowe są hostowane w centrum danych o najwyższej klasy zabezpieczeniach",
          "Bezpłatne, automatyczne aktualizacje w chmurze, zapewniające nowe interesujące funkcje i zasoby"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 lub późniejsze"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 lub późniejsze"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 lub późniejsze"]
      ],
      "browser": [
        ["Chrome", "v49.0", "bieżące"],
        ["Firefox", "v38.0", "bieżące"],
        ["Safari", "v11.0", "bieżące"],
        ["Edge", "v83.0.478.45", "bieżące"],
        ["Internet Explorer", "v10.0", "v11.0 lub późniejsze"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "Nowej generacji oprogramowanie Boardmaker już tu jest!  Boardmaker 7 oferuje najlepsze funkcje wszystkich wcześniejszych wersji Boardmaker w jednej wielojęzykowej aplikacji na różne platformy.  Boardmaker 7 posiada uproszczony interfejs użytkownika, który zapewnia szybki dostęp do potrzebnych narzędzi.  Obejmuje najnowsze symbole PCS, a pomimo tego jest wstecznie kompatybilny ze starszymi tablicami i ćwiczeniami. Dzięki temu nowemu oprogramowaniu możesz szybciej niż kiedykolwiek tworzyć i wykorzystywać zaadaptowane materiały pomocnicze do komunikacji i nauki.",
    "topReasons": {
      "header": "Najważniejsze powody, dla których warto kupić Boardmaker 7",
      "points": [
        "Edytuj, drukuj i odtwarzaj wszystkie starsze pliki Boardmaker",
        "Intuicyjny, nowoczesny interfejs z wbudowanymi wskazówkami i materiałami szkoleniowymi",
        "Świetne szablony, które można szybko i łatwo personalizować",
        "Szybko wyszukuj potrzebne symbole i obrazki"
      ]
    },
    "summaryEnd": "Pobierz bezpłatną 30-dniową wersję próbną już dziś!",
    "features": [
      {
        "featureTitle": "Otwiera wszystko, co jest Twoim dziełem",
        "featureDescription": "Nie zmarnuj wszystkich lat wytężonej pracy... dzięki oprogramowaniu Boardmaker 7 możesz otwierać wszystkie pliki utworzone w programach Boardmaker 5, Boardmaker 6 i Boardmaker Studio.  Konwersja jest szybka i precyzyjna, dlatego nawet złożone ćwiczenia interaktywne będą działać i wyglądać tak jak oryginał."
      },
      {
        "featureTitle": "Tylko spokojnie",
        "featureDescription": "Przemówili użytkownicy!  Interfejs Boardmaker 7, zaprojektowany w oparciu o rozległe testy użytkowników, takich jak Ty, jest teraz nowoczesny, przyjazny i intuicyjny w obsłudze.  Wbudowane wskazówki i materiały szkoleniowe pozwolą Ci ufnie odkrywać, rozwijać umiejętności i, co najważniejsze, wspierać uczniów."
      },
      {
        "featureTitle": "Szybkie działanie i oszczędność czasu",
        "featureDescription": "Dzięki przeprojektowanym szablonom do ćwiczeń interaktywnych i do druku możesz osiągać zachwycające rezultaty w zaledwie kilka minut.  Harmonogram czy historyjkę dla uczniów przygotujesz migiem, co pozwoli Ci poświęcić więcej czasu samym podopiecznym.  Boardmaker ułatwia także personalizowanie przygotowanych materiałów, dlatego uzyskujesz idealną kombinację prędkości z elastycznością."
      },
      {
        "featureTitle": "Wyjątkowe wyszukiwanie symboli",
        "featureDescription": "Symbole świadczą o nas samych. Boardmaker 7 posiada ulepszoną funkcję wyszukiwania symboli, która pozwala intuicyjnie przeglądać symbole uszeregowane w kategorie... ale to zaledwie początek.  Można wyszukiwać fragmenty słów, rymujące się słowa, poszczególne fonemy i schematy spółgłosek/samogłosek. To najbardziej funkcjonalne narzędzie wyszukiwania dostępne na rynku!  A gdyby nie udało się znaleźć pewnego symbolu, zintegrowane narzędzia kamery i wyszukiwania w internecie pozwolą Ci szybko i łatwo dodać zdjęcia."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 lub późniejsze"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 lub późniejsze"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 lub późniejsze"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 lub nowszy"],
        ["Android", "Urządzenia Tobii Dynavox serii T", ""]
      ],
      "eyeTracker": [
        [
          "PCEye Mini,",
          "PCEye Explore,",
          "PCEye Go,",
          "EyeMobile,",
          "I-12,",
          "I-15"
        ]
      ]
    }
  }
}
